import { useQuery } from "@tanstack/react-query";
import { calculateDeliveryCost } from "../services/fulfillmentService";


// Change this from useMutation to useQuery to track changes reactively
export const useCalculateDeliveryCost = (payload, options = {}) => {
  return useQuery({
    queryKey: ["deliveryCost", payload.deliveryType, payload.latitude, payload.longitude, payload.items],
    queryFn: () => calculateDeliveryCost(payload),
    ...options,
  });
};